import { DropRectangle, RMLine, RMRectangle } from 'business/models/CustomModels';

export default class WellRect {
  public drop: Array<Array<DropRectangle | RMLine>>;
  public ing: Array<RMRectangle | RMLine>;
  public wells: Array<RMRectangle>;

  constructor() {
    this.drop = [];
    this.ing = [];
    this.wells = [];
  }
}
